// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1agpF","info":"PatientInfo_info__2UKho"};